import styled from 'styled-components';
import { CustomTagManager } from '../utils/GTM';
import popupBg from './assets/app-popup-bg.webp';

const PopupDimmedWrap = styled.div`
  width: 100%;
  max-width: 480px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
`;

const PopupWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: clamp(calc(320px * 0.8), 80vw, calc(480px * 0.8));
  height: clamp(
    calc(320px * 0.8 * 1.33),
    calc(80vw * 1.33),
    calc(480px * 0.8 * 1.33)
  );
  font-size: 0;

  img#app-popup-background {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    image-rendering: high-quality;
    border-radius: 24px;
  }

  button#app-popup-close {
    width: 25%;
    height: 18%;
    position: absolute;
    top: 12px;
    right: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 1;
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }

  a#app-popup-link {
    width: 100%;
    height: 14%;
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
    color: transparent;
    cursor: pointer;
    z-index: 1;
    -webkit-tap-highlight-color: transparent;
  }
`;

const AppPopup = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return <img src={popupBg} alt="app-popup" style={{ display: 'none' }} />;
  }
  return (
    <PopupDimmedWrap>
      <PopupWrap>
        <button
          type="button"
          id="app-popup-close"
          title="close"
          onClick={onClose}
        />
        <img
          id="app-popup-background"
          src={popupBg}
          alt="app-popup"
          onError={(e) => {
            e.target.src = './img/app-popup-bg.png';
          }}
        />
        <a
          id="app-popup-link"
          onClick={() =>
            CustomTagManager.QR_Download_Page_Popup_Ranking_Clicked()
          }
          href="https://4cut-ranking.com/app-download-redirect.html"
        >
          https://4cut-ranking.com/app-download-redirect.html
        </a>
      </PopupWrap>
    </PopupDimmedWrap>
  );
};

export default AppPopup;
